export const RESUME_SESSION_MODAL_ASSET_REFERENCE =
  '@clientos/resume-session-modal-mfe';

// One-shot marker: set by ListenerManager right before redirecting away after
// "Start a New Session", read (and cleared) by SessionManager on the very
// next trigger match so it doesn't re-prompt for the session being discarded.
export const DISCARDED_SESSION_STORAGE_KEY =
  'shell-onboarding-agent-discarded-session';
